import { localise } from 'customHooks/useLocalised/useLocalised';
import * as textKeys from 'data/translationKeys';

const translations = localise(Object.values(textKeys).map(textKey => textKey));

export default translations;
